import { mount } from "@vue/test-utils";
import OfferElement from "@/components/core/OfferElement";

describe("OfferElement test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(OfferElement);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component OfferElement", () => {
    expect(wrapper).toBeDefined();
  });
});
